export enum ProductCategoriesRoutes {
  Index = '/products/categories',
  Create = '/products/categories/create',
  Update = '/products/categories/:id/update',
  Details = '/products/categories/:id/details',
}

export enum ProductsRoutes {
  Index = '/products',
  Create = '/products/create',
  Update = '/products/:id/update',
  Details = '/products/:id/details',
}
